import React, { useState } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../stores/AuthContext';
import './Auth.css';

const SignUp: React.FC = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // Client-side validation
    if (password1 !== password2) {
      setError('Passwords do not match');
      return;
    }

    if (password1.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    setLoading(true);

    try {
      await signup(username, email, password1, password2);
      // Only navigate on successful signup
      navigate('/app/dashboard', { replace: true });
    } catch (err) {
      // Handle different error types
      if (err instanceof Error) {
        setError(err.message);
      } else if (typeof err === 'string') {
        setError(err);
      } else {
        setError('Sign up failed. Please check your information and try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="logo">
            <span className="logo-icon">🐋</span>
            <span className="logo-text">Orca</span>
          </div>
          <h2>Create Account</h2>
          <p>Sign up to get started with Orca</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <Alert severity="error">{error}</Alert>}

          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            fullWidth
            autoComplete="username"
            placeholder="Choose a username"
          />

          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            fullWidth
            autoComplete="email"
            placeholder="Enter your email"
          />

          <TextField
            label="Password"
            type="password"
            value={password1}
            onChange={(e) => setPassword1(e.target.value)}
            required
            fullWidth
            autoComplete="new-password"
            placeholder="Create a password (min. 8 characters)"
            slotProps={{ htmlInput: { minLength: 8 } }}
          />

          <TextField
            label="Confirm Password"
            type="password"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            required
            fullWidth
            autoComplete="new-password"
            placeholder="Confirm your password"
          />

          <Button type="submit" variant="contained" size="large" fullWidth disabled={loading}>
            {loading ? 'Creating account...' : 'Sign Up'}
          </Button>
        </form>

        <div className="auth-footer">
          <p>
            Already have an account? <Link to="/app/login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;

